var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "financeApplication__form" },
    [
      _c("ValidationObserver", { ref: "observer" }, [
        _c(
          "div",
          { class: _vm.classNames },
          [
            _c("ValidationProvider", {
              attrs: { name: "years", rules: _vm.validationRules, slim: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    return [
                      _c(
                        "FinanceApplicationRow",
                        {
                          attrs: {
                            id: "employYears",
                            label: "Years",
                            "error-message": errors[0],
                          },
                        },
                        [
                          _c("FinanceApplicationText", {
                            attrs: {
                              type: "number",
                              id: "employYears",
                              placeholder: "Enter Years",
                            },
                            model: {
                              value: _vm.years,
                              callback: function ($$v) {
                                _vm.years = $$v
                              },
                              expression: "years",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: { name: "months", rules: _vm.monthsValidationRules },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    return [
                      _c(
                        "FinanceApplicationRow",
                        {
                          attrs: {
                            id: "employYears",
                            label: "Months",
                            "error-message": errors[0],
                          },
                        },
                        [
                          _c("FinanceApplicationText", {
                            attrs: {
                              type: "number",
                              id: "employMonths",
                              placeholder: "Enter Months",
                            },
                            model: {
                              value: _vm.months,
                              callback: function ($$v) {
                                _vm.months = $$v
                              },
                              expression: "months",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "financeApplication__additionalText" }, [
        _vm._v(
          "\n        Please note, if your current employment is under 3 years, you'll need to provide another.\n    "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }